﻿export class ResultPage<T> {
    items: T[];
    pageIndex: number;
    totalItemCount: number;
}